import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle, withState, branch, renderComponent } from 'recompose'
import { push } from 'connected-react-router'
import { track } from 'utils/trackingUtils'
import { Flow } from 'constants/flowConstants'

import * as UserSelectors from 'modules/user/selectors'
import * as UserActions from 'modules/user/actions'
import * as OrgActions from 'modules/org/actions'
import * as OrgSelectors from 'modules/org/selectors'
import * as ExperimentSelectors from 'modules/experiment/selectors'
import * as RoutingSelectors from 'modules/routing/selectors'
import * as recaptcha from 'utils/recaptcha'
import { page, getVideoSignupReferrer } from 'utils/trackingUtils'
import { isEmailValid } from 'utils/email'

import VideoSignupCard from './video-signup-component'
import SignupCard from './component'

import { api as orgApi } from 'modules/org/api'
import { api as userApi } from 'modules/user/api'


const mapStateToProps = state => ({
  password: UserSelectors.getPassword(state),
  email: UserSelectors.getEmail(state) || '',
  name: UserSelectors.getName(state),
  createOrgError: OrgSelectors.getCreateOrgError(state),
  validEmail: UserSelectors.getValidEmail(state),
  splitLoading: ExperimentSelectors.getLoading(state),
  checkEmailIsSSOEnabledPending: UserSelectors.checkEmailIsSSOEnabledPending(state),
  createOrgLoading: OrgSelectors.getCreateOrgLoading(state),
  search: RoutingSelectors.getSearch(state),
  pathname: RoutingSelectors.getPathname(state),
  disabledEmail: UserSelectors.getDisabledEmail(state),
  domainFound: UserSelectors.hasAssociatedDomain(state),
  existingFlow: UserSelectors.getFlow(state),
  hidePopup: UserSelectors.isPopupHidden(state), 
  emailIsSSOEnabled: UserSelectors.emailIsSSOEnabled(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    setPassword: UserActions.setPassword,
    setName: UserActions.setName,
    setValidEmail: UserActions.setValidEmail,
    resetOrgError: OrgActions.resetOrgError,
    setEmail: UserActions.setEmail,
    fetchClearbitForEmail: UserActions.fetchClearbitForEmail,
    checkEmailIsSSOEnabled: UserActions.checkEmailIsSSOEnabled,
    getLoginUrl: UserActions.getLoginUrl,
    checkEmailIsSSOEnabledFailed: UserActions.checkEmailIsSSOEnabledFailed,
    exchangeGoogleCodeForDriftCode: OrgActions.exchangeGoogleCodeForDriftCode,
    findAssociatedDomain: UserActions.findAssociatedDomain,
    setHidePopup: UserActions.setHidePopup,
    push,
  }, dispatch),
})

export default compose(
  withState('hideError', 'setHideError', false),  
  withState('verifyEmailError', 'setVerifyEmailError', false),
  withState('verifyEmailLoading', 'setVerifyEmailLoading', false),
  withState('solvedCaptcha', 'setSolvedCaptcha', false),
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({
    componentDidMount() {
      const { setSolvedCaptcha } = this.props
      recaptcha.initialize(setSolvedCaptcha)

      if (this.props.email) {
        this.props.actions.findAssociatedDomain()
      }
      page('Onboarding Account Setup', {
        context: window.location.pathname.includes('video') ? 'video' : 'widget-onboarding',
        videoReferralSource: getVideoSignupReferrer()
      })
    }
  }),
  withHandlers({
    onEmailChange: props => event => {
      props.actions.setEmail(event.target.value)
      props.setHideError(true)
      props.actions.setValidEmail(true)
      props.onValueChange && props.onValueChange()
      props.actions.findAssociatedDomain()
    },
    onPasswordChange: props => event => {
      props.actions.setPassword(event.target.value)
      props.onValueChange && props.onValueChange()
    },
    onNameChange: props => event => {
      props.actions.setName(event.target.value)
      props.onValueChange && props.onValueChange()
    },
    onProcessingGoogleCode: props => event => {
      if (event.code) {
        props.actions.exchangeGoogleCodeForDriftCode(event.code)
      }
    },
    onProcessingExternalGoogleCode: props => event => {
      props.actions.exchangeGoogleCodeForDriftCode({ code: event, pathname: props.pathname })
    },
    onProcessingMicrosoftCode: props => event => {
      if (event) {
        props.actions.exchangeMicrosoftCodeForDriftCode({ code: event, pathname: props.pathname })
      }
    },
    onFindMyTeamClick: props => () => {
      track('Onboarding Find My Team Accepted', {
        context: 'verify email step'
      })
      props.actions.push('/start/findTeam/verify')
    },
    onVideoSignInClick: props => () => {
      track('Onboarding Setup Sign-In Clicked', {
        context: 'verify email step',
        product: 'video'
      })
      window.location.replace(props.loginUrl)
    },
    onCreateNewAccount: props => () => {
      props.actions.setHidePopup(true)
    },
    onVideoCreateNewAccount: props => () => {
      props.actions.setEmail("")
      props.actions.setName("")
      props.actions.setPassword("")
      props.actions.resetOrgError(null)
    },
    onContinueClick: props => () => {
      const verifyEmail = () => orgApi.verifyEmail({ name: props.name, email: props.email, password: props.password })
        .then(() => props.actions.push('/start/verify'))
        .catch(err => {
          console.error(err)
          props.setHideError(false)
          props.setVerifyEmailError(true)
          props.setVerifyEmailLoading(false)
        })


      if(props.hidePopup || (!(props.flow === Flow.VIDEO) && !props.domainFound) || (props.flow === Flow.VIDEO && !props.showVideoSignInNotice)){
        if (isEmailValid(props.email) ) {
          props.setVerifyEmailLoading(true)

          userApi.checkEmailIsSSOEnabled2(props.email)
            .then(({ data }) => !!data?.canLogIn 
                ? props.actions.getLoginUrl() 
                : verifyEmail()
            .catch(err => { 
              console.error(err)
              props.actions.checkEmailIsSSOEnabledFailed()
            })
          )
        } else {
          props.setHideError(false)
          props.actions.setValidEmail(false)
        }
      }
     }
    },
  ),
  branch(props => props.flow === Flow.VIDEO || props.flow === Flow.HYFY_MIGRATION, renderComponent(VideoSignupCard))
)(SignupCard)
